import Navbar from '../components/navbar';
import Footer from '../components/footer';
import '../App.scss';

import bird from '../components/images/notfound-bird.png';

const Home = () => {
    return (
		<div className="App">
			<header>
				<Navbar></Navbar>
			</header>
		  
			<body>
				<div className='comingsoon white'>
					<img src={bird} alt="silhouette of a dead red bird lying down" id="nfBird"></img>
					<br/>
					<br/>
					<br/>
					<h1>Page not found.</h1>

				</div>
				<Footer/>
			</body>
		</div>
	  );
}

export default Home;
